import { getDeviceId } from '@bz/socket';

import { TrackEventName as EventName, TrackEvent as Event } from './event';
import sensors from './sensors';
import initBzTrackEvent from './bz';

Event.safeOn(EventName.INIT, () => {
  sensors.init();
});

initBzTrackEvent();

/** 暴露神策的包装后的方法 */
export const sensorsEvent = { ...sensors };
export const trackEvent = {
  ...EventName,
  trackOn: Event.safeOn,
  trackEmit: Event.emit,
};

// 获取一些基本信息
export const getBasicInfo = () => {
  if (!import.meta.env.SSR) {
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const queryParams = Object.fromEntries(params.entries());
    const deviceId = getDeviceId() || '';
    const pseudoId = localStorage.getItem('pseudoId');
    const channelType = String(queryParams.channelType || 0);
    return {
      deviceId,
      pseudoId,
      channelType,
    };
  } else {
    return {
      deviceId: '',
      pseudoId: '',
      channelType: '0',
    };
  }
};
